export const AtlassianIntelligence = () => {
    return (
        <section id="atlassian-intelligence">
            <h2>Weave AI into all of your work</h2>
            <hr />
        </section>
    );
};
